import { IStandardAPIResponse } from "../vm";
import { handleErrorResp, httpClient } from "./UtilService";

export const getAlertDetails = (
  path: string,
  thresholdObj: any,
  value: any
): { showAlert: boolean; msg?: string, isLessThan?: boolean } => {
  if (!value || thresholdObj == null)
    return {
      showAlert: false,
    };

  const pathArray = path.split(".");
  let threshold: any;
  switch (pathArray.length) {
    case 2:
      threshold = thresholdObj[pathArray[0]]?.[pathArray[1]];
      break;
    case 3:
      threshold = thresholdObj[pathArray[0]]?.[pathArray[1]]?.[pathArray[2]];
      break;
    default:
      threshold = thresholdObj[path];
  }
  if (!threshold)
    return {
      showAlert: false,
    };
  let msg;
  let isLessThan;
  switch (threshold?.type) {
    case "lessThan":
      value = Number(value);
      if (value >= threshold.value) {
        msg = `Entered value is out of range. Value should be less than ${threshold.value}`;
        isLessThan = false;
        // msg = `Entered value is greater than the threshold value ${threshold.value}`
      }
      break;
    case "greaterThan":
      value = Number(value);
      if (value <= threshold.value) {
        msg = `Entered value is out of range. Value should be greater than ${threshold.value}`;
        isLessThan = true;
      }
      break;
    case "range":
      value = Number(value);
      if (value > threshold.max || value < threshold.min) {
        msg = `Entered value is out of range. Value should be in range ${threshold.min} to ${threshold.max}`;
        if (value > threshold.max) {
        isLessThan = false
        }
        if (value < threshold.min) {
        isLessThan = true
        }
      }
      break;
  }

  return { showAlert: msg ? true : false, msg, isLessThan };
};

export async function getThreshold(
  type: string
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`thresholds/${type}`, "GET");
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export const isInThreshold = (value: any, path: string, threshold: any) => {
  const { showAlert, msg } = getAlertDetails(path, threshold, value);
  return showAlert;
};

export const isValueLessThanThreshold = (value: any, path: string, threshold: any) => {
  const {isLessThan } = getAlertDetails(path, threshold, value);
  return isLessThan;
};

